import React, { Component } from "react";

import Select from "react-select";

class MultiSelect extends Component {
  constructor(props) {
    super(props);

    this.state = {
      options: null,
    };
  }
  handleChange = (newValue, actionMeta) => {
    this.props.callback(newValue ? newValue.map(tag => tag.value) : []);
    this.setState({ options: newValue });
  };
  render() {
    return (
      <Select
        isMulti={true}
        onChange={this.handleChange}
        options={this.props.options}
        value={this.state.options || this.props.defaultTags}
        placeholder={this.props.placeholder || "Search..."}
        initialValue={this.props.defaultTags}
        className={`basic-multi-select w-100 ttc ${this.props.className}`}
        styles={{
          menu: provided => {
            return { ...provided, zIndex: 2001 };
          },
        }}
      />
    );
  }
}

export default MultiSelect;
